import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from "./views/login";
import ChangePassword from "./views/change-password";
import Dashboard from "./views/dashboard";
import SingleImage from "./views/single";
import NotFound from "./views/404";
import PrivateRoute from "./components/private-route";

const Routes = (props) => (
<Switch>
	<PrivateRoute path="/" exact component={Dashboard} authProps = {props.authProps} />
	<PrivateRoute path="/image/:bucket/:id" exact component={SingleImage} authProps = {props.authProps} />
	<Route path="/login" exact component={Login}></Route>
	<Route path="/change-password" exact component={ChangePassword}></Route>
	<Route component={NotFound}></Route>
</Switch>
)
export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js